export const linkboardAccess = {
  "AccessTable.ClientList.Row": "client-list-row",
};
